<template>
  <b-modal
    v-if="modalData"
    v-model="modalFlow"
    centered
    hide-header-close
    hide-footer
    hide-header
    size="sm"
    body-class="paywall-body"
    content-class="paywall-content"
  >
    <div class="paywall-discount-badge">
      <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_ii_711_15170)">
          <path d="M67.3688 24.4538C67.455 23.8013 67.5 23.1488 67.5 22.5C67.5 13.5788 59.4637 6.42 50.5462 7.63125C47.9475 3.0075 42.9975 0 37.5 0C32.0025 0 27.0525 3.0075 24.4538 7.63125C15.5175 6.42 7.5 13.5788 7.5 22.5C7.5 23.1488 7.545 23.8013 7.63125 24.4538C3.0075 27.0562 0 32.0062 0 37.5C0 42.9938 3.0075 47.9437 7.63125 50.5462C7.54474 51.1939 7.50089 51.8466 7.5 52.5C7.5 61.4212 15.5175 68.5612 24.4538 67.3688C27.0525 71.9925 32.0025 75 37.5 75C42.9975 75 47.9475 71.9925 50.5462 67.3688C59.4637 68.5612 67.5 61.4212 67.5 52.5C67.5 51.8512 67.455 51.1987 67.3688 50.5462C71.9925 47.9437 75 42.9938 75 37.5C75 32.0062 71.9925 27.0562 67.3688 24.4538Z" fill="url(#paint0_linear_711_15170)"/>
        </g>
        <defs>
          <filter id="filter0_ii_711_15170" x="0" y="-4" width="75" height="82" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="1.5"/>
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.375 0 0 0 0 0.979167 0 0 0 0.38 0"/>
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_711_15170"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="-4"/>
            <feGaussianBlur stdDeviation="2"/>
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.557692 0 0 0 0 0.0836538 0 0 0 0 0 0 0 0 0.43 0"/>
            <feBlend mode="normal" in2="effect1_innerShadow_711_15170" result="effect2_innerShadow_711_15170"/>
          </filter>
          <linearGradient id="paint0_linear_711_15170" x1="37.5" y1="0" x2="37.5" y2="75" gradientUnits="userSpaceOnUse">
            <stop stop-color="#AD31ED"/>
            <stop offset="1" stop-color="#EE0557"/>
          </linearGradient>
        </defs>
      </svg>
      <p v-if="modalData.discountRate">
        {{ modalData.discountRate }}%
      </p>
    </div>
    <div
      class="cursor-pointer fw-700"
      style="position: absolute; top: 12px; right: 16px; z-index: 3; color: #686868; font-size: 24px; text-shadow: 1px 0 2px rgb(253,253,253), -1px 0 2px rgb(246,237,248), 0 1px 2px rgb(253,253,253), 0 -1px 4px #7B390066, 0 2px 2px #6B000080"
      @click="modalFlow = false"
    >
      x
    </div>
    <div
      class="paywall-inner"
      :style="`background-image: url(${modalData.popupProfileImage})`"
    >
      <p style="font-weight: 800">
        {{ modalData.popupHeader }}
      </p>
      <p style="font-size: 16px; color: #FDFF6C">
        {{ modalData.popupText }}
      </p>
      <p style="font-size: 16px; color: #ED0558">
        {{ modalData.popupSubtitle }}
      </p>
      <div class="paywall-button">
        <div
          v-if="modalData.webProduct && modalData.popupAction === 'product'"
          @click="buyProduct({banner: modalData, name: 'buy', params: {productId: modalData.webProduct, purchaseSource: 'popup-with-user-1'}, query: {campaignId: modalData.campaignId, campaignType: modalData.campaignType}})">
          <b-button
            class="mb-1 btn-primary2 w-100"
            type="submit"
            variant="primary"
            block
          >
            {{ modalData.popupButtonText }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton, BModal,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BModal,
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    modalData: {
      default: () => ({}),
      required: true,
    },
    modalModel: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      modalFlow: this.modalModel,
    }
  },
  watch: {
    modalModel(val) {
      this.modalFlow = val
    },
    modalFlow(val) {
      this.$emit('update:modalModel', val)
    },
  },
  methods: {
    buyProduct(product) {
      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'buy-button',
              params: {
                id: product.banner.iosProduct,
              },
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'buy-button',
            params: {
              id: product.banner.androidProduct,
            },
          }))
        }
      } else {
        this.$router.push({
          name: product.name,
          params: product.params,
          query: product.query,
        })
      }
    },
  },
}
</script>

<style lang="scss">
.paywall-content {
  border-radius: 36px;

  .paywall-body {
    padding: 0 !important;
    margin: 0 !important;
    position: relative;
    border-radius: 36px;

    .paywall-discount-badge {
      position: absolute;
      left: -16px;
      top: -16px;
      width: 75px;
      height: 75px;

      svg {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 3;
      }

      p {
        font-family: 'Poppins', sans-serif;
        font-size: 20px;
        font-weight: 800;
        color: #fff;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 4;
        position: relative;
      }
    }

    .paywall-inner {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      z-index: 2;
      justify-content: flex-end;
      align-items: center;
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      min-height: 520px;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
        z-index: 2;
      }

      p {
        font-family: 'Poppins', sans-serif;
        color: #fff;
        font-size: 18px;
        font-weight: 500;
        z-index: 3;
        text-align: center;
        margin-bottom: 2px;

        &:first-of-type {
          margin-bottom: 14px;
        }
      }

      .paywall-button {
        width: 100%;
        padding: 0 24px;
        margin-bottom: 8px;
        margin-top: 8px;
        z-index: 3;
      }
    }
  }
}
</style>
